/* eslint-disable react-refresh/only-export-components */
import { useEffect, useState } from 'react'
import { CheckCircle, AlertCircle, Info, X } from 'lucide-react'

type ToastType = 'success' | 'error' | 'info'

interface Toast {
  id: string
  type: ToastType
  message: string
}

// Estado global mínimo — para uso sin librerías externas
let listeners: ((toasts: Toast[]) => void)[] = []
let toasts: Toast[] = []

function notify(type: ToastType, message: string) {
  const id = Math.random().toString(36).slice(2)
  toasts = [...toasts, { id, type, message }]
  listeners.forEach((l) => l(toasts))
  setTimeout(() => dismiss(id), 3000)
}

function dismiss(id: string) {
  toasts = toasts.filter((t) => t.id !== id)
  listeners.forEach((l) => l(toasts))
}

export const toast = {
  success: (msg: string) => notify('success', msg),
  error: (msg: string) => notify('error', msg),
  info: (msg: string) => notify('info', msg),
}

const icons = {
  success: <CheckCircle size={18} />,
  error: <AlertCircle size={18} />,
  info: <Info size={18} />,
}

export default function ToastContainer() {
  const [items, setItems] = useState<Toast[]>([])

  useEffect(() => {
    listeners.push(setItems)
    return () => {
      listeners = listeners.filter((l) => l !== setItems)
    }
  }, [])

  if (!items.length) return null

  return (
    <div className="toast-container">
      {items.map((t) => (
        <div key={t.id} className={`toast toast-${t.type}`}>
          {icons[t.type]}
          <span>{t.message}</span>
          <button onClick={() => dismiss(t.id)}>
            <X size={14} />
          </button>
        </div>
      ))}
    </div>
  )
}
